import React from 'react';
import warningIcon from '../../../assets/images/shared/icons/warning-icon.svg';
import {
  addToCartEventsUA,
  addToCartEventsGA4,
} from '../../data_layer/ga_add_to_basket_events';

class SimpleAddToBasket extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: parseFloat(props.prodDeliveryMinOrder),
      buttonDisabled: false,
      linesAttributes: {},
      show: false,
    };
    this.increment = this.increment.bind(this);
    this.decrement = this.decrement.bind(this);
    this.deliveryButtonClick = this.deliveryButtonClick.bind(this);
    this.validateMultipleInput = this.validateMultipleInput.bind(this);
    this.manualInputChange = this.manualInputChange.bind(this);
    this.checkDeliveryQuantityValid =
      this.checkDeliveryQuantityValid.bind(this);
    this.pushToBasket = this.pushToBasket.bind(this);
    this.displaySuccessfulUpdate = this.displaySuccessfulUpdate.bind(this);
    this.setValueFromInput = this.setValueFromInput.bind(this);
    this.setVisibility = this.setVisibility.bind(this);
  }

  componentWillMount() {
    this.setVisibility(this.props.prodDeliveryMinOrder);
  }

  setVisibility(quant) {
    let isVisible =
      parseFloat(this.state.value) <= parseFloat(this.props.prodMinOrder) ||
      parseFloat(this.state.value) >= parseFloat(this.props.prodMaxQuant) ||
      parseFloat(this.state.value) <=
        parseFloat(this.props.prodDeliveryMinOrder)
        ? false
        : true;
    this.setState({ show: isVisible });
  }

  validateMultipleInput(quantity) {
    if (quantity % this.props.prodMinOrder !== 0) return false;
    return true;
  }

  manualInputChange(e) {
    const re = /^[0-9\b]+$/;
    if (e.target.value === '' || re.test(e.target.value)) {
      this.setValueFromInput(e.target.value);
    }
  }

  setValueFromInput(quantity) {
    if (quantity < +this.props.prodDeliveryMinOrder) {
      this.setState({ buttonDisabled: true, show: false });
      return false;
    }
    if (quantity % this.props.prodMinOrder !== 0 || quantity <= 0) {
      this.setState({ buttonDisabled: true, value: this.props.prodMinOrder });
      return false;
    }
    if (quantity > this.props.prodMaxQuant) {
      this.setState({ buttonDisabled: true, value: this.props.prodMinOrder });
      return false;
    }
    this.checkDeliveryQuantityValid(quantity);
  }

  decrement() {
    this.setState(
      (prevState, props) => {
        return {
          value:
            prevState.value > +props.prodMinOrder && prevState.value > 0
              ? prevState.value - props.prodMinOrder
              : props.prodMinOrder,
        };
      },
      () => {
        if (this.state.value < +this.props.prodDeliveryMinOrder) {
          this.setState({ buttonDisabled: true, show: false });
          return false;
        }
        if (
          this.state.value - +this.props.prodMinOrder >=
          +this.props.prodMinOrder
        ) {
          this.setState({ buttonDisabled: false, show: true });
          this.checkDeliveryQuantityValid(this.state.value);
        }
        this.setVisibility(this.state.value);
      },
    );
  }

  increment() {
    this.setState(
      ({ value }, { prodMinOrder }) => {
        return { value: value + prodMinOrder };
      },
      () => {
        const { value } = this.state;
        const { prodDeliveryMinOrder, prodMaxQuant } = this.props;
        if (value < +prodDeliveryMinOrder) {
          this.setState({ buttonDisabled: true });
          return false;
        }
        if (value >= prodMaxQuant) {
          return this.setState({ value: prodMaxQuant });
        }
        return this.checkDeliveryQuantityValid(value);
      },
    );
  }

  checkDeliveryQuantityValid(quantity) {
    if (parseFloat(quantity) < +this.props.prodMinOrder) {
      this.setState({ buttonDisabled: true, value: this.props.prodMinOrder });
      return false;
    }
    if (parseFloat(quantity) > +this.props.prodMaxQuant) {
      this.setState({ buttonDisabled: false, value: this.props.prodMinOrder });
      return false;
    }
    this.setState({ buttonDisabled: false, value: +quantity });
  }

  checkBasketTypeAndPush(quantity, skipBackOrderCheck) {
    if (!this.validateMultipleInput(quantity)) {
      return false;
    }
    this.setState(
      {
        linesAttributes: {
          skip_back_order_check: skipBackOrderCheck,
          lines_attributes: {
            0: { product_id: this.props.productStepId, quantity: quantity },
          },
        },
      },
      () => {
        const guest_basket = {};
        const customer_basket = {};
        if (this.props.signedIn == true) {
          Object.assign(customer_basket, this.state.linesAttributes);
        } else {
          Object.assign(guest_basket, this.state.linesAttributes);
        }
        const basketType =
          this.props.signedIn == true ? { customer_basket } : { guest_basket };
        this.pushToBasket(quantity, basketType);
      },
    );
  }

  backOrderPopUp(quantity, stock, myref, totalQuantity) {
    let etaStockMessage =
      `<h1><img src="${warningIcon}" class="warning-icon" alt="" width="27" height="30"> Insufficient Stock</h1>` +
      `<div class="bootbox-body__text-container">
        <p>There is currently 0 in stock</p>
        <hr class="back-order__divider">
        <p>This product is currently out of stock and will be dispatched when available. We will notify you with an estimated delivery date.</p>
        <p class="back-order__confirmation"><input class="back-order__checkbox" onchange="document.getElementsByClassName('btn-confirm')[0].disabled = !this.checked;" type="checkbox" value="1"> I am aware this item is out of stock and delivery dates will be confirmed.</p>
      </div>`;
    if (totalQuantity > stock) {
      if (stock > 0) {
        etaStockMessage =
          `<h1><img src="${warningIcon}" class="warning-icon" alt="" width="27" height="30"> Insufficient Stock</h1>` +
          `<div class="bootbox-body__text-container">
            <p>There is currently <span class="bold-number">${stock}</span> in stock</p>
            <hr class="back-order__divider">
            <p><span class="bold-number">${stock}</span> will be dispatched with your order. The remaining <span class="bold-number">${
            totalQuantity - stock
          }</span> will be dispatched when available. We will notify you with an estimated delivery date.</p>
            <p>Cable sold by the metre will be delivered when the full quantity is available.</p>
            <p class="back-order__confirmation">
              <input class="back-order__checkbox" onchange="document.getElementsByClassName('btn-confirm')[0].disabled = !this.checked;" type="checkbox" value="1"> I am aware there is insufficient stock and delivery dates will be confirmed.
            </p>
          </div>`;
      }

      bootbox.dialog({
        message: etaStockMessage,
        size: 'large',
        buttons: {
          cancel: {
            label: 'Cancel',
            className: 'btn-cancel',
            callback: () => {
              myref.innerHTML = 'Add to Basket';
              document
                .querySelector('.basket-preview-price-wrapper')
                .classList.remove('is-loading');
            },
          },
          confirm: {
            label: 'Place on Back Order',
            className: 'btn-confirm',
            callback: () => {
              this.checkBasketTypeAndPush(quantity, 'true');
            },
          },
        },
      });

      document.getElementsByClassName('btn-confirm')[0].disabled = true;
    }
  }

  deliveryButtonClick(quantity) {
    this.myref.innerHTML = "<div class='loader'></div>";
    this.checkBasketTypeAndPush(quantity, false);
  }

  pushToBasket(quantity, basketInfo) {
    const { isAddingToBasket, gaEventsData } = this.props;

    let basketInfoWrapper = document.querySelector(
      '.basket-preview-price-wrapper',
    );
    basketInfoWrapper.classList.add('is-loading');
    isAddingToBasket();
    $.ajax({
      type: 'PUT',
      url: this.props.url,
      contentType: 'application/json',
      data: JSON.stringify(basketInfo),
      dataType: 'json',
      headers: { Accept: 'application/json' },
    })
      .done(data => {
        if (data.back_order_flag === true) {
          this.backOrderPopUp(
            quantity,
            this.props.stockLevel,
            this.myref,
            data.total_quantity,
          );
        } else {
          this.setState({ basketSuccess: true });
          this.displaySuccessfulUpdate(data);
          PubSub.publish('FETCH-USER-CREDIT-LIMIT', true);

          // Google Analytics Add to Basket Events
          addToCartEventsUA({ event: 'addBasket', options: gaEventsData });
          addToCartEventsGA4({
            event: 'add_to_cart_ga4',
            options: gaEventsData,
          });
        }
      })
      .error(() => {
        this.setState({ basketSuccess: false });
      })
      .always(() => {
        isAddingToBasket();
      });
  }

  displaySuccessfulUpdate(data) {
    setTimeout(() => {
      const basketInfoWrapper = document.querySelector(
        '.basket-preview-price-wrapper',
      );
      const basketItems = basketInfoWrapper.querySelector('.basket-items');
      const basketPreviewPrice = basketInfoWrapper.querySelector(
        '.basket-preview-price',
      );
      const basketCount = basketInfoWrapper.querySelector('.basket-count');
      basketInfoWrapper.classList.remove('is-loading');
      basketItems.innerHTML = data.lines;
      basketPreviewPrice.innerHTML = data.total;
      basketCount.innerHTML = data.mobile_count;
      this.setState({ basketSuccess: false });
    }, 2500);
  }

  handleKeyPress(value) {
    if (value === 'decrement') {
      this.decrement();
      return;
    }
    this.increment();
  }

  render() {
    const { buttonDisabled, basketSuccess, value } = this.state;
    const { addingToBasket, addValue } = this.props;
    const basketSuccessClass = basketSuccess === true ? ' btn-successful' : '';
    return (
      <div className="product--listings_add-to-basket">
        <div className="quantity-selector" key={value}>
          <button
            className="minus-quantity"
            onClick={this.decrement}
            role="button"
            tabIndex={0}
            onKeyPress={() => this.handleKeyPress('decrement')}
            aria-label="Decrease the product quantity">
            <i className="icon-minus" />
          </button>
          <input
            className="quantity-selector__input"
            type="text"
            defaultValue={value}
            onBlur={this.manualInputChange.bind(this)}
          />
          <button
            className="plus-quantity"
            onClick={this.increment}
            role="button"
            tabIndex={0}
            onKeyPress={() => this.handleKeyPress('increment')}
            aria-label="Increase the product quantity">
            <i className="icon-plus" />
          </button>
        </div>
        <div className="delivery_section">
          <button
            className={`btn-green btn-full-width delivery-basket-button ${basketSuccessClass}`}
            onClick={this.deliveryButtonClick.bind(this, value)}
            disabled={buttonDisabled || addingToBasket}
            type="button"
            ref={ref => (this.myref = ref)}>
            {basketSuccess === true ? 'Added to Basket' : addValue}
          </button>
        </div>
      </div>
    );
  }
}

export default SimpleAddToBasket;
